import React from "react";
import classes from "./ActionsIcons.module.css";

import duplicateImg from "../assests/UI/duplicate.png";
import deleteImg from "../assests/UI/delete.png";
import upImg from "../assests/UI/double-up.png";
import downImg from "../assests/UI/double-down.png";

const DuplicateIcon = ({ onClick, width }) => {
    return <div className={`${classes.Duplicate} ${classes.Icon}`} onClick={onClick} style={{ width: width }}>
        <img src={duplicateImg} ></img>
    </div>
}
const DeleteIcon = ({ onClick, width }) => {
    return <div className={`${classes.Duplicate} ${classes.Icon}`} onClick={onClick} style={{ width: width }}>
        <img src={deleteImg} ></img>
    </div>
}

const UpIcon = ({ onClick, width, className }) => {
    return <div className={`${classes.Duplicate} ${classes.Icon} ${className}`} onClick={onClick} style={{ width: width }}>
        <img src={upImg} ></img>
    </div>
}

const DownIcon = ({ onClick, width, className }) => {
    return <div className={`${classes.Duplicate} ${classes.Icon} ${className}`} onClick={onClick} style={{ width: width }}>
        <img src={downImg} ></img>
    </div>
}

export { DuplicateIcon, DeleteIcon, UpIcon, DownIcon };